import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DashboardState {
  activeView: 'team' | 'individual' | 'custom' | 'pipeline' | 'analytics';
  selectedPeriod: 'month' | 'quarter' | 'year' | 'custom';
  selectedUsers: string[];
  filters: {
    dateRange: {
      start_date: string;
      end_date: string;
    };
    userId?: string;
    territory?: string;
    status?: string;
  };
}

const initialState: DashboardState = {
  activeView: 'team',
  selectedPeriod: 'month',
  selectedUsers: [],
  filters: {
    dateRange: {
      start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
      end_date: new Date().toISOString().split('T')[0],
    },
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setActiveView: (state, action: PayloadAction<DashboardState['activeView']>) => {
      state.activeView = action.payload;
    },
    setSelectedPeriod: (state, action: PayloadAction<DashboardState['selectedPeriod']>) => {
      state.selectedPeriod = action.payload;
      
      if (action.payload === 'month') {
        const now = new Date();
        state.filters.dateRange = {
          start_date: new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0],
          end_date: new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0],
        };
      } else if (action.payload === 'quarter') {
        const now = new Date();
        const quarter = Math.floor(now.getMonth() / 3);
        const startMonth = quarter * 3;
        state.filters.dateRange = {
          start_date: new Date(now.getFullYear(), startMonth, 1).toISOString().split('T')[0],
          end_date: new Date(now.getFullYear(), startMonth + 3, 0).toISOString().split('T')[0],
        };
      } else if (action.payload === 'year') {
        const now = new Date();
        state.filters.dateRange = {
          start_date: new Date(now.getFullYear(), 0, 1).toISOString().split('T')[0],
          end_date: new Date(now.getFullYear(), 11, 31).toISOString().split('T')[0],
        };
      }
    },
    setSelectedUsers: (state, action: PayloadAction<string[]>) => {
      state.selectedUsers = action.payload;
    },
    setDateRange: (state, action: PayloadAction<{ start_date: string; end_date: string }>) => {
      state.filters.dateRange = action.payload;
      state.selectedPeriod = 'custom';
    },
    setFilters: (state, action: PayloadAction<Partial<DashboardState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.selectedPeriod = 'month';
      state.selectedUsers = [];
    },
  },
});

export const {
  setActiveView,
  setSelectedPeriod,
  setSelectedUsers,
  setDateRange,
  setFilters,
  resetFilters,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;